import { SilverView } from './silver';

export function SilverScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <SilverView />
    </div>
  );
}
